import { render, staticRenderFns } from "./land-more-info-gp.vue?vue&type=template&id=23c55a22"
import script from "./land-more-info-gp.vue?vue&type=script&lang=js"
export * from "./land-more-info-gp.vue?vue&type=script&lang=js"
import style0 from "./land-more-info-gp.vue?vue&type=style&index=0&id=23c55a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports